module.exports = __webpack_public_path__ + "img/healthcare.6846ba6a.png";